import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

// Every chat call answers with the same handful of non-field errors. Map the
// ones the UI has fixed copy for; everything else passes through as-is so the
// notification shows the server's own text (e.g. the 400 field error under
// `message`).
const toChatError = (error) => {
  const status = error?.response?.status;
  if (status === 429) {
    return { detail: "Please wait a moment." };
  }
  if (status === 404) {
    return { detail: "This order is not available." };
  }
  if (
    error?.response &&
    error?.response?.data &&
    typeof error?.response?.data === "object"
  ) {
    return error?.response?.data;
  }
  return error?.message;
};

// The whole thread of one order — plain array, oldest first, not paginated.
// `orderId` is the numeric `id` of the history row, never `order_id`.
export const getOrderMessages = createAsyncThunk(
  "orderChat/get",
  async ({ orderId }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/orders/${orderId}/messages/`
      );
      return data;
    } catch (error) {
      return rejectWithValue(toChatError(error));
    }
  }
);

// 201 returns the stored row (direction INBOUND), which the slice appends.
export const sendOrderMessage = createAsyncThunk(
  "orderChat/send",
  async ({ orderId, message }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/orders/${orderId}/messages/`,
        { message }
      );
      return data;
    } catch (error) {
      return rejectWithValue(toChatError(error));
    }
  }
);

// Marks the store's replies read. `upToId` is the newest message actually
// rendered, so a reply landing mid-render is not cleared by accident; omit it
// to mark everything. Answers { unread_count }.
export const markOrderChatRead = createAsyncThunk(
  "orderChat/read",
  async ({ orderId, upToId }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/orders/${orderId}/messages/read/`,
        upToId !== undefined && upToId !== null ? { up_to_id: upToId } : {}
      );
      return data;
    } catch (error) {
      return rejectWithValue(toChatError(error));
    }
  }
);
